export const getMode = () => localStorage.getItem("mode");

export const setMode = (value) => localStorage.setItem("mode", value);